import { render, staticRenderFns } from "./RebaseFooter.vue?vue&type=template&id=94b335b6"
import script from "./RebaseFooter.vue?vue&type=script&lang=js"
export * from "./RebaseFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports